/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Blocklist_Update_FailedInputs */

const en_carrier_blocklist_update_failed = /** @type {(inputs: Carrier_Blocklist_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update blocklist`)
};

const es_carrier_blocklist_update_failed = /** @type {(inputs: Carrier_Blocklist_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar la lista de bloqueo`)
};

/**
* | output |
* | --- |
* | "Failed to update blocklist" |
*
* @param {Carrier_Blocklist_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_blocklist_update_failed = /** @type {((inputs?: Carrier_Blocklist_Update_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Blocklist_Update_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_blocklist_update_failed(inputs)
	return es_carrier_blocklist_update_failed(inputs)
});